import { render } from "./RootPage.vue?vue&type=template&id=2d4add80"
import script from "./RootPage.vue?vue&type=script&lang=js"
export * from "./RootPage.vue?vue&type=script&lang=js"
script.render = render

export default script